import React, { Component } from 'react';

const Report = () => {
	return ( <h1>Run a Report</h1> );
}
 
export default Report;